<template>
  <div class="container">
    <div v-if="courseListData.length > 0">
      <div
        class="purchased-box"
        v-for="(item, index) in courseListData"
        :key="index"
      >
        <div class="page-headers footer-tabs">
          <div class="page-header-left">
            <div class="page-header-content">
              {{ (item.course && item.course.title) || "-" }}
              <span
                v-if="item.completion_status === 2"
                class="mwow-tag danger-filled large"
                >已结课</span
              >
            </div>
          </div>
          <div class="page-header-control">
            <div class="mwow-button primary" @click="clickorder(item)">
              续费
            </div>
            <div
              class="mwow-button warning"
              v-if="item.stop_status == 1 && item.completion_status == 1"
              @click="clickClassbtn('stop', item)"
            >
              停课
            </div>
            <div
              class="mwow-button warning"
              v-if="item.stop_status == 2 && item.completion_status == 1"
              @click="clickClassbtn('resume', item)"
            >
              复课
            </div>
            <div
              class="mwow-button info"
              v-if="item.completion_status == 1"
              @click="clickClassbtn('finish', item)"
            >
              结课
            </div>
          </div>
        </div>
        <div class="purchased-details">
          <div class="beleft">剩余课时：{{ item.usable_number }}课时</div>
          <div v-if="item.stop_status == 1">
            <div v-if="item.expire_status == 0">
              <span
                >最终到期时间：{{
                  item.expire_time != 0
                    ? dateYearMonthDay(Number(item.expire_time + "000"))
                    : "未设置"
                }}</span
              >
              <span class="notDue" v-if="item.expire_time != 0">未到期</span>
            </div>
            <div v-else>
              <span
                >最终到期时间：{{
                  item.expire_time != 0
                    ? dateYearMonthDay(Number(item.expire_time + "000"))
                    : "未设置"
                }}</span
              >
              <span class="notDue">已到期</span>
            </div>
          </div>
          <div v-else>
            <div>
              <span
                >最终到期时间：停课中 （{{
                  item.stop_end_time != 0
                    ? dateYearMonthDay(Number(item.stop_end_time + "000")) +
                      " 复课"
                    : "未设置复课时间"
                }}）</span
              >
            </div>
          </div>
        </div>
        <div class="purchased-details">
          <div class="purchased-class">
            <span>所在班级：</span>
            <div v-if="item.class_list.length > 0">
              <div
                class="purchased-lable"
                v-for="classitem in item.class_list"
                :key="classitem.class_id"
                @click="goclassDetails(classitem)"
              >
                {{ classitem.name }}
              </div>
            </div>
            <div v-else>-</div>
          </div>
        </div>
        <el-table
          size="mini"
          ref="multipleTable"
          v-horizontal-scroll
          tooltip-effect="dark"
          style="width: 100%; margin-top: 20px"
          stripe
          :data="item.order_item_course_list_item"
        >
          <el-table-column label="订单号" prop="order_no">
            <template slot-scope="scope">
              <span
                class="ordernum editBtn"
                @click="toDetail(scope.row.order_id)"
                >{{ scope.row.order_no }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="购买课时" prop="original_buy_number">
          </el-table-column>
          <el-table-column label="赠送课时" prop="original_give_number">
          </el-table-column>
          <el-table-column label="已耗课数" prop="used_number">
          </el-table-column>
          <el-table-column label="转退课时" prop="refund_number">
          </el-table-column>
          <el-table-column label="剩余课时">
            <template slot-scope="scope">
              <div>
                {{ scope.row.usable_number }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="课程有效期" width="200">
            <template slot-scope="scope">
              <div class="sortBox" v-if="!!scope.row.sortBtn">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                  v-model="dateTimes"
                  :picker-options="expireTimeOption"
                >
                </el-date-picker>
                <div
                  class="mwow-button primary"
                  @click="sortComfirsClick(scope.row)"
                >
                  确定
                </div>
              </div>
              <div class="sortBox" v-else>
                <span class="showeditBtn">{{
                  scope.row.course_end_time_date
                }}</span>
                <i
                  class="el-icon-edit-outline showedit"
                  @click="sortIconClick(scope.row)"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="230"
          >
            <template slot-scope="scope">
              <!-- <div
                class="mwow-button primary"
                v-if="scope.row.usable_number > 0"
                @click="getorderclearrecord(item, scope.row)"
              >
                课时清零
              </div>
              <div v-else>-</div> -->
              <div
                class="mwow-button danger"
                style="margin-left: 10px"
                v-if="
                  Number(scope.row.usable_number) > 0 &&
                  item.completion_status === 1 &&
                  item.expire_status === 0
                "
                @click="toOrderRefund(scope.row)"
              >
                退课
              </div>
              <div
                class="mwow-button inter"
                style="margin-left: 10px"
                v-if="
                  Number(scope.row.usable_number) > 0 &&
                  item.completion_status === 1 &&
                  item.expire_status === 0
                "
                @click="toOrderTransfer(scope.row)"
              >
                转课
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="courseListData.length == 0">
      <el-empty
        :image-size="32"
        description="暂无数据"
        image="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/nodata.png"
      ></el-empty>
    </div>
    <detailsDialog
      v-if="showDialog"
      :type="dialogType"
      :itemdata="dialogidetailsid"
      @back="dialogHide"
    />
  </div>
</template>
<script>
import detailsDialog from "../detailsDialog.vue";
import {
  courseList,
  getcourseFinish,
  set_expire_time,
  postorderclean,
} from "@/api/studyDetails";

export default {
  components: {
    detailsDialog,
  },
  // @Prop() sid!: number;
  // @Prop() detailsData?: any;
  props: ["sid", "detailsData"],
  data() {
    return {
      courseListData: [], //已经购买表格
      showDialog: false, //弹框开关
      dialogidetailsid: 0, //弹框id
      dateTimes: "", // 设置课程有效期
      id: 0,
      expireTimeOption: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        },
      },
    };
  },
  created() {
    this.id = this.sid;
    this.getCourseList({
      student_id: this.sid,
    });
  },
  methods: {
    //已购课程
    getCourseList(id) {
      const _t = this;
      courseList(id).then((res) => {
        if (res.error_code == 0) {
          if (res.data.list != null) {
            res.data.list.map((item) => {
              if (
                item.order_item_course_list_item != null &&
                item.order_item_course_list_item.length > 0
              ) {
                item.order_item_course_list_item.map((a) => {
                  a.sortBtn = false;
                  a.course_end_time_date =
                    a.course_end_time != 0
                      ? _t.dateYearMonthDay(Number(a.course_end_time + "000"))
                      : "未设置";
                });
              }
            });
          }
          _t.courseListData = res.data.list;
        }
      });
    },
    // 时间格式化
    dateYearMonthDay(unixtime) {
      const dateTime = new Date(unixtime);
      const year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      if (month > 0 && month < 10) {
        month = "0" + month;
      }
      let day = dateTime.getDate();
      if (day > 0 && day < 10) {
        day = "0" + day;
      }
      const timeSpanStr = year + "-" + month + "-" + day;
      return timeSpanStr;
    },
    // 续费
    clickorder(e) {
      const _t = this;
      if (e.course.delete_time > 0) {
        _t.$message({
          type: "error",
          message: "课程已删除",
        });
        return;
      }
      if (e.course.sales_status == 2) {
        _t.$message({
          type: "error",
          message: "课程已关闭购买",
        });
        return;
      }
      if (_t.detailsData.status == 3) {
        _t.$confirm(
          "历史学员在完成缴费后，状态将自动转为在读，并移动至在读学员列表。确定要缴费？",
          `缴费 - ${_t.detailsData.name}`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            iconClass: "mwow-icon-error",
          }
        )
          .then(() => {
            _t.$router.push({
              name: "buyCourseConfirm",
              query: { id: _t.id, course_id: e.course_id },
            });
          })
          .catch(() => {});
        return;
      }
      _t.$router.push({
        name: "buyCourseConfirm",
        query: { id: _t.id, course_id: e.course_id },
      });
    },
    clickClassbtn(type, item) {
      const _t = this;
      // 结课
      if (type == "finish") {
        _t.$confirm(
          "结课后，课程下的所有剩余课时都将被清零，此操作无法恢复。",
          `结课 - ${item.course.title}`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            type: "warning",
          }
        )
          .then(() => {
            setTimeout(() => {
              getcourseFinish({ account_id: item.account_id, force: 0 }).then(
                (res) => {
                  if (res.error_code == 0) {
                    _t.getCourseList({
                      student_id: _t.id,
                    });
                    _t.$message({
                      type: "success",
                      message: "结课成功",
                    });
                  } else if (res.error_code == 21015005) {
                    _t.$confirm(
                      `${res.message}`,
                      `结课 - ${item.course.title}`,
                      {
                        confirmButtonText: "确定",
                        confirmButtonClass: "mwow-button-filled success mini",
                        cancelButtonText: "取消",
                        cancelButtonClass: "mwow-button-filled mini",
                        type: "warning",
                      }
                    )
                      .then(() => {
                        getcourseFinish({
                          account_id: item.account_id,
                          force: 1,
                        }).then((res) => {
                          if (res.error_code == 0) {
                            _t.getCourseList({
                              student_id: _t.id,
                            });
                            _t.$message({
                              type: "success",
                              message: "结课成功",
                            });
                          }
                        });
                      })
                      .cath(() => {});
                    return;
                  }
                }
              );
            }, 100);
          })
          .catch(() => {});
        return;
      }
      _t.dialogType = type;
      _t.dialogidetails = item;
      const itemData = item;
      _t.dialogidetailsid = itemData;
      _t.showDialog = true;
    },
    goclassDetails(e) {
      this.$router.push({
        name: "classManageDetail",
        query: {
          id: e.class_id,
        },
      });
    },
    // 订单详情
    toDetail(id) {
      sessionStorage.setItem(
        "student_order_refund_route_history",
        JSON.stringify({
          student_id: this.$route.query.id,
        })
      );
      this.$router.push({
        name: "orderManageDetail",
        query: {
          id: String(id),
        },
      });
    },
    // 确定
    sortComfirsClick(e) {
      const _t = this;
      let end_time = 0;
      if (_t.dateTimes != "") {
        end_time = _t.dateTimes / 1000;
      } else {
        _t.$message({
          type: "error",
          message: "请选择日期",
        });
        return;
      }
      e.sortBtn = false;
      set_expire_time({
        order_item_course_id: e.order_item_course_id,
        end_time: end_time,
      }).then((res) => {
        if (res.error_code == 0) {
          _t.$message({
            type: "success",
            message: "修改成功!",
          });
          _t.getCourseList({
            student_id: _t.id,
          });
        } else {
          _t.$message({
            type: "error",
            message: "修改失败!" + res.message,
          });
        }
      });
    },
    sortIconClick(e) {
      const _t = this;
      _t.courseListData.map((item) => {
        if (
          item.order_item_course_list_item != null &&
          item.order_item_course_list_item.length > 0
        ) {
          item.order_item_course_list_item.map((a) => {
            a.sortBtn = false;
          });
        }
      });
      e.sortBtn = true;
      _t.dateTimes = e.course_end_time != 0 ? e.course_end_time + "000" : "";
    },
    // 课时清零
    // getorderclearrecord(
    //   item: { course: { title: string } },
    //   scope: { student_id: number; order_item_course_id: number }
    // ) {
    //   var _t = this as any;
    //   _t.$confirm(
    //     "清零后，对应订单下的剩余课时将被清零，此操作无法恢复。",
    //     `课时清零 - ${item.course.title}`,
    //     {
    //       confirmButtonText: "确定",
    //       confirmButtonClass: "mwow-button-filled success mini",
    //       cancelButtonText: "取消",
    //       cancelButtonClass: "mwow-button-filled mini",
    //       type: "warning",
    //     }
    //   )
    //     .then(() => {
    //       postorderclean({
    //         order_item_course_id: scope.order_item_course_id,
    //       }).then((res: any) => {
    //         if (res.error_code == 0) {
    //           _t.$message({
    //             type: "success",
    //             message: "课时清零成功!",
    //           });
    //           _t.getCourseList({ student_id: scope.student_id });
    //         }
    //       });
    //     })
    //     .catch(() => {});
    // }
    // 退课
    toOrderRefund(row) {
      this.$router.push({
        name: "orderRefund",
        query: {
          item_ids: row.item_id,
          sid: row.student_id,
          complete: "1", // 全款购买或者分期完成购买
        },
      });
    },
    // 转课
    toOrderTransfer(row) {
      this.$router.push({
        name: "orderTransfer",
        query: {
          iid: row.item_id,
          sid: row.student_id,
        },
      });
    },
    // 停课弹框
    dialogHide(e) {
      const _t = this;
      _t.showDialog = false;
      if (e == "stop") {
        _t.getCourseList({
          student_id: _t.id,
        });
      } else if (e == "resume") {
        _t.getCourseList({
          student_id: _t.id,
        });
      } else if (e == "add" || e == "edit" || e == "followUp" || e == "close") {
        _t.getfollowlistData({
          student_id: _t.id,
        });
      } else if (e == "EaidsDetails") {
        _t.getDetails(
          {
            student_id: _t.id,
          },
          () => {
            _t.getCourseList({
              student_id: _t.id,
            });
          }
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
.purchased-box {
  margin-bottom: 25px;
  background: #f6fafc;
  padding: 22px 16px;
}
//页头
.page-headers {
  padding: 13px;
  display: flex;
  justify-content: space-between;
}
.footer-tabs {
  border: none;
  padding: 0;
  .page-header-control {
    div {
      margin: 0;
    }
  }
}
.page-header-left {
  display: flex;
  cursor: pointer;
  position: relative;
  align-items: center;
}
.page-header-content {
  font-size: 13px;
  font-weight: bold;
  color: #5c5d5e;
}
.page-header-control {
  display: flex;
  div:nth-of-type(2) {
    margin: 0 10px;
  }
}
.purchased-details {
  font-size: 12px;
  color: #5c5d5e;
  display: flex;
  margin-top: 20px;
  .beleft {
    margin-right: 70px;
  }
  .notDue {
    margin-left: 18px;
    color: #07d1aa;
  }
  .purchased-class {
    display: flex;
    align-items: center;
  }
}
.page-header-content {
  color: #5c5d5e;
  font-size: 14px;
}
.purchased-lable {
  padding: 7px 15px;
  background: #ffffff;
  color: #07d1aa;
  margin-right: 10px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.ordernum {
  cursor: pointer;
  color: #07d1aa;
}
</style>
